import { supabase } from '@/integrations/supabase/client';

/**
 * Build fetch headers carrying the current user's Supabase access token.
 * Server routes guarded by requireAdminUser / requireAuthenticatedUser need this.
 */
export async function authHeaders(
  extra: Record<string, string> = {},
): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  return {
    ...extra,
    Authorization: `Bearer ${data.session?.access_token ?? ''}`,
  };
}
